const sv = {
    required: "Obligatoriskt"
}
export default sv;